export default __webpack_public_path__ + "static/media/footer-logo-linkedin.6bff2a35.svg";